import React, { ReactElement } from 'react';

import style from 'views/components/UI/LinearProgress/linearProgress.module.scss';

const LinearProgress = (): ReactElement => (
  <div className={style.overlay}>
    <div className={style.loader}>
      <div className={style.loaderBar} />
    </div>
  </div>
);

export { LinearProgress };
